import { list } from "postcss";

const tabs = document.querySelectorAll('.js-tab-btn');
const lists = document.querySelectorAll('.tabs-component .links-list');

function initTabs() {
    tabs[0].classList.add('active');
    lists[0].classList.remove('hidden');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(currentTab => {
                currentTab.classList.contains('active') && currentTab.classList.remove('active');
            })
            tab.classList.add('active');

            const listToShow = document.querySelector(`ul[data-label='${tab.id}']`);

            lists.forEach(currentList => {
                !currentList.classList.contains('hidden') && currentList.classList.add('hidden');
            })

            listToShow.classList.remove('hidden');
        })
    })
}

export { initTabs }
